import {
    DescripteursFormation,
    DescripteursFormationRequest,
    DescripteursGroupement,
    DescripteursGroupementRequest,
    DescripteursObjetFormation,
    DescripteursObjetFormationRequest,
    DescripteursObjetMaquette,
    DescripteursObjetMaquetteRequest
} from '@pcscol/odf-api-v1-angular';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ObjetMaquetteService } from '../../services/objet-maquette.service';
import { ObjetMaquette } from '../objet-maquette.model';
import { ObjetMaquetteUndoCommand } from './command';
import { CommandEvents } from './command-events';

export class ModifierDescripteurObjetMaquetteCommand extends ObjetMaquetteUndoCommand<ObjetMaquette> {
    constructor(
        codeStructure: string,
        id: string,
        version: string,
        events: CommandEvents,
        objetMaquetteService: ObjetMaquetteService,
        private oldDescripteursObjetMaquette: DescripteursObjetMaquette,
        private newDescripteursObjetMaquette: DescripteursObjetMaquette
    ) {
        super(codeStructure, id, version, events, objetMaquetteService);
    }

    do(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursObjetMaquette(this.id, this.version, this.toRequest(this.newDescripteursObjetMaquette))
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    undo(): Observable<ObjetMaquette> {
        return this.objetMaquetteService
            .modifierDescripteursObjetMaquette(this.id, this.version, this.toRequest(this.oldDescripteursObjetMaquette))
            .pipe(tap(om => this.events.objetMaquetteModifie$.next(om)));
    }

    private toRequest(value: DescripteursObjetMaquette): DescripteursObjetMaquetteRequest {
        return descripteursObjetMaquetteToRequest(value);
    }
}

export function descripteursObjetMaquetteToRequest(
    value: DescripteursFormation | DescripteursGroupement | DescripteursObjetFormation
): DescripteursFormationRequest | DescripteursObjetFormationRequest | DescripteursGroupementRequest {
    let champsOptionnels = {};
    if ((value as DescripteursObjetFormation)?.nature) {
        champsOptionnels = {
            value: (value as DescripteursObjetFormation).nature?.code ?? (value as DescripteursObjetFormation).nature
        };
    }
    if ((value as DescripteursObjetFormation | DescripteursFormation).type) {
        champsOptionnels = {
            ...champsOptionnels,
            type:
                (value as DescripteursObjetFormation | DescripteursFormation).type?.code ??
                (value as DescripteursObjetFormation | DescripteursFormation).type
        };
    }
    return {
        ...value,
        ...champsOptionnels
    };
}
